module.exports = __webpack_public_path__ + "img/step4.e95eb1dc.png";